import { createWebAppAuthTokenUrl } from './createWebAppAuthTokenUrl';

export const redirectToWebapp = (token: string) => {
  window.location.assign(createWebAppAuthTokenUrl(token));
};
